const dashboard = {
  dashboard: 'Dashboard',
};
export default dashboard;
